import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Capture the deep link BEFORE Angular bootstraps. The OAuth library navigates to
// '/' after SSO completes, which would otherwise discard the originally requested route.
try {
  const path = window.location.pathname || '/';
  const isCallback = path.startsWith('/callback');
  const isLogout = path.startsWith('/logout');
  const isRoot = path === '/' || path === '' || path === '/home';
  if (!isCallback && !isLogout && !isRoot) {
    sessionStorage.setItem('mdm.deepLink', path + window.location.search);
  }
} catch {
  /* sessionStorage unavailable */
}

if (environment.production) {
  enableProdMode();
}

async function bootstrap(): Promise<void> {
  try {
    // Fetch runtime config BEFORE Angular bootstraps so the Compass oauth
    // APP_INITIALIZER sees window.serverlessOAuthConfig and takes the serverless path.
    const res = await fetch('/appsettings.json', { headers: { Accept: 'application/json' } });
    if (res.ok) {
      const config: any = await res.json();
      (window as any).serverlessOAuthConfig = {
        serverless: true,
        clientId: config.clientId,
        rbacEnabled: true,
        rbacAppName: config.rbacAppName,
        revalidateAfterMin: 30,
        sessionExpirationAlertInMin: 3,
        longestTimeToLiveHours: 8,
        autoLogoutOnSessionExpired: true,
        logoutUrl: config.baseUrls?.logout,
        environmentConfig: config,
      };
    }
  } catch {
    // If appsettings cannot be pre-fetched, fall through: AppComponent.ngOnInit still
    // configures serverless handling. Bootstrapping must not be blocked by this optimization.
  }

  // Angular 22 defaults to zoneless by default. `provideZoneChangeDetection()` has no effect
  // with the legacy `bootstrapModule()` API (Angular guards against that combination) — the
  // NgModule-compatible way to opt back into zone.js-driven change detection is `ngZone: 'zone.js'`.
  await platformBrowser().bootstrapModule(AppModule, {
    ngZone: 'zone.js',
  });
}

bootstrap().catch(err => console.error(err));
